import React from "react";
import { Dialog } from "@mui/material";
import {
  DangerButton,
  PrimaryButton,
  QuietButton,
  SheetBody,
  SheetFoot,
  SheetHead,
  sheetPaperProps,
} from "./groupBasketStyles";

/*
 * One confirmation for every basket action that cannot be undone: leave,
 * remove a member, drop unpaid items, cancel. `children` carries anything
 * extra the action needs (the cancel reason, the refund notice).
 */
const GroupConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = "Go back",
  destructive = false,
  busy = false,
  error = "",
  onConfirm,
  onClose,
  children,
}) => {
  const ConfirmButton = destructive ? DangerButton : PrimaryButton;
  return (
    <Dialog open={Boolean(open)} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs" PaperProps={sheetPaperProps}>
      <SheetHead>
        <div>
          <h2>{title}</h2>
          {message ? <p>{message}</p> : null}
        </div>
      </SheetHead>
      {(children || error) && (
        <SheetBody>
          {children}
          {error ? (
            <p role="alert" style={{ margin: 0, color: "#a43118", fontSize: 14, fontWeight: 700 }}>
              {error}
            </p>
          ) : null}
        </SheetBody>
      )}
      <SheetFoot>
        <QuietButton type="button" onClick={onClose} disabled={busy}>
          {cancelLabel}
        </QuietButton>
        <ConfirmButton type="button" onClick={onConfirm} disabled={busy}>
          {busy ? "One moment" : confirmLabel}
        </ConfirmButton>
      </SheetFoot>
    </Dialog>
  );
};

export default GroupConfirmDialog;
